import React, { Component } from "react";

import { defined } from "@formant/core/common/defined";
import { IAdapter } from "@formant/core/model/IAdapter";

import { adapterStore, appStore } from "../../../stores";
import { Buttons } from "../../common/Buttons";
import { ActionButton } from "../ActionButton";

export interface IActionsProps {
    adapter: IAdapter;
}

export class Actions extends Component<IActionsProps> {
    public render() {
        return (
            <Buttons>
                <ActionButton
                    icon="delete"
                    onClicked={this.onDelete}
                    data-tooltip="Remove adapter"
                />
            </Buttons>
        );
    }

    private onDelete = () => {
        const { adapter } = this.props;
        const { name, id } = adapter;
        appStore.setConfirm({
            title: "Delete Adapter",
            message: `Delete adapter "${name}"?`,
            onOk: async () => {
                await adapterStore.delete(defined(id));
                appStore.setSnackbar("Adapter deleted");
            },
        });
    };
}
